import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import CSS from 'csstype';
import { debounce } from 'lodash-es';
import React, { useEffect, useRef, useState } from 'react';
import { unstable_batchedUpdates } from 'react-dom';

import { BracketIcon } from '~/src/dash/components/icons/misc-icons';
import { Div, fontSizing } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

type TextInputPrefix = 'search' | 'search_alt';

interface IMobileTextInputProps {
  enableClear?: boolean; // displays clear button on right
  handleOnChange: (text: string) => void;
  inputStyle?: CSS.Properties;
  msDelay?: number; // add delay to debounce. default 0. recommended 300 or 500 if needing debounce
  placeholder?: string;
  prefix?: TextInputPrefix; // displays icon/symbol on left
}

export const MobileTextInput = ({
  enableClear,
  handleOnChange,
  inputStyle = {},
  msDelay = 0,
  placeholder,
  prefix,
}: IMobileTextInputProps) => {
  const isMounted = useRef(false);
  const inputRef = useRef(null);
  const [text, setText] = useState('');

  const onChange = (e: React.FormEvent<HTMLInputElement>) => {
    debouncedOnChange(e.currentTarget.value);
  };

  const debouncedOnChange = debounce(setText, msDelay);

  useEffect(() => {
    if (isMounted.current) {
      handleOnChange(text);
    }
    isMounted.current = true;
  }, [text]);

  const handleClear = () => {
    // @ts-ignore // typescript has an issue with ref values
    inputRef.current.value = '';
    unstable_batchedUpdates(() => {
      setText('');
    });
  };

  return (
    <Div style={{ width: '100%' }}>
      <Div>
        <input
          ref={inputRef}
          className='text-input-base'
          type='text'
          placeholder={placeholder}
          onChange={onChange}
          style={{
            background: publicaColors.veryLightGray,
            border: `0.5px solid ${publicaColors.lightGray}`,
            borderRadius: '3px',
            fontFamily: `"Roboto", "Helvetica", "Arial", sans-serif`,
            fontSize: fontSizing.base,
            paddingTop: '8px',
            paddingRight: enableClear ? '30px' : '12px',
            paddingBottom: '8px',
            paddingLeft: prefix ? '30px' : '12px',
            width: '100%',
            ...inputStyle,
          }}
        />
      </Div>
      {prefix && (
        <Div
          style={{
            position: 'absolute',
            top: '10px',
            left: '6px',
            height: '16px',
          }}
        >
          {prefix === 'search' && (
            <SearchIcon
              style={{
                color: publicaColors.gray,
                height: '16px',
              }}
            />
          )}
          {prefix === 'search_alt' && (
            <BracketIcon
              color={publicaColors.gray}
              style={{
                height: '16px',
                marginLeft: '6px',
                paddingBottom: '1px',
              }}
            />
          )}
        </Div>
      )}
      {enableClear && text !== '' && (
        <Div
          onClick={handleClear}
          style={{
            position: 'absolute',
            top: '9px',
            right: '6px',
            height: '16px',
          }}
        >
          <ClearIcon
            style={{
              color: publicaColors.gray,
              height: '16px',
            }}
          />
        </Div>
      )}
    </Div>
  );
};
